import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out
  const [org, setOrg] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrg(data.organization);
    } catch {
      setUser(false);
      setOrg(null);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("pi360_token")) refresh();
    else setUser(false);
  }, [refresh]);

  const login = (token, u) => {
    localStorage.setItem("pi360_token", token);
    setUser(u);
    refresh();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("pi360_token");
    setUser(false);
    setOrg(null);
  };

  return (
    <AuthContext.Provider value={{ user, org, login, logout, refresh, setOrg }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
